// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"install"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 21H21V15H3V21Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8 3.00012H3V21.0001H21V3.00012H16M21 21H3V15H21V21ZM6.99805 17.9981H7.00195V18.002H6.99805V17.9981ZM9.99805 17.9981H10.002V18.002H9.99805V17.9981Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M8.5 8.04385L12 11.5041L15.5 8.04385M12 10.3V3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-install')
export default class InstallIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'install',
    }
  }
}
